import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { IBets } from '@GFTypes/Responses/AuthenticateResponse';
import { IBetState, ICurrencyValue } from '@GameStore/GameStoreSchema';
import { IBalanceData } from '@GFTypes/Responses/BalanceData';
import { IAccountBonusData } from '@GFTypes/GameStoreTypes/Account';

export const processBetData = (data: {
    defaults?: IBets;
    account: IBalanceData;
    currentState: IBetState;
    bonuses: IAccountBonusData;
    lastBaseGameBet?: number;
}): IBetState => {
    let currentBetIndex: number;
    let currentBetValue: ICurrencyValue;

    let maxBetValue: ICurrencyValue;
    let maxBetIndex: number;

    let betSteps: Array<ICurrencyValue>;
    let availableBetSteps: Array<ICurrencyValue>;

    const freeSpins = data.bonuses.freeSpins;

    if (data.defaults) {
        betSteps = data.defaults.steps.map((bet) => CurrencyUtils.createCurrencyValue(bet));
    } else {
        betSteps = data.currentState.betSteps;
    }

    availableBetSteps = betSteps.filter((bet) => bet.raw <= data.account.balance);
    if (availableBetSteps.length === 0) availableBetSteps.push(CurrencyUtils.createCurrencyValue(betSteps[0].raw));

    maxBetIndex = availableBetSteps.length - 1;
    maxBetValue = availableBetSteps[maxBetIndex];

    if (data.defaults) {
        currentBetIndex = data.lastBaseGameBet
            ? availableBetSteps.findIndex((x) => x.raw === data.lastBaseGameBet)
            : availableBetSteps.findIndex((x) => x.raw === data.defaults?.default);
        if (currentBetIndex < 0) currentBetIndex = maxBetIndex;
    } else {
        currentBetIndex = availableBetSteps[data.currentState.index] ? data.currentState.index : maxBetIndex;
    }

    currentBetValue = freeSpins?.balance ? CurrencyUtils.createCurrencyValue(freeSpins.wagerCost) : availableBetSteps[currentBetIndex];

    const bets = {
        index: currentBetIndex,
        value: currentBetValue,
        currencySymbol: CurrencyUtils.getCurrencySymbol(),

        maxIndex: maxBetIndex,
        maxValue: maxBetValue,

        betSteps: betSteps,
        availableBetSteps: availableBetSteps,
        available: freeSpins?.balance ? freeSpins?.balance > 0 : data.account.balance >= currentBetValue.raw,
        lastBaseGameBet: data.lastBaseGameBet
    };

    return bets;
};
